module.exports = __webpack_public_path__ + "media/images/players/CHACARRA_EUGENIO-155ad70bb9e8635106e24610f553c1ee.png";